document.addEventListener("DOMContentLoaded", function () {
  initTripsitterProductAnimations();
});

function initTripsitterProductAnimations() {
  const config = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
    selectors: [
      ".tripsitter-product__header",
      ".tripsitter-product__image-card",
      ".tripsitter-product__stage-card",
      ".tripsitter-product__cta",
    ],
  };

  const observer = createScrollObserver(config);
  const elements = document.querySelectorAll(config.selectors.join(", "));

  if (elements.length > 0) {
    observeElements(observer, elements);
  }
}

function createScrollObserver(config) {
  const observerOptions = {
    threshold: config.threshold,
    rootMargin: config.rootMargin,
  };

  return new IntersectionObserver(function (entries) {
    entries.forEach(handleElementIntersection);
  }, observerOptions);
}

function handleElementIntersection(entry) {
  if (entry.isIntersecting && !entry.target.classList.contains("animated")) {
    entry.target.classList.add("animate");
    entry.target.classList.add("animated");
    entry.target.observer?.unobserve(entry.target);
  }
}

function observeElements(observer, elements) {
  elements.forEach((element) => {
    element.observer = observer;
    observer.observe(element);
  });
}
